
import React from 'react';
import { 
  MessageSquare, 
  Camera,
  CreditCard,
  Video,
  CalendarCheck,
  Bell,
  QrCode,
  Map,
  UserCircle,
  Sparkles
} from 'lucide-react';
import FunctionalityCard from './FunctionalityCard';

const functionalities = [
  {
    icon: <MessageSquare className="w-5 h-5 text-orcsys-500" />,
    title: "Messagerie instantanée",
    description: "Communiquez en temps réel avec vos clients et collaborateurs."
  },
  {
    icon: <Video className="w-5 h-5 text-orcsys-500" />,
    title: "Appels vidéo",
    description: "Organisez des réunions virtuelles avec partage d'écran."
  },
  {
    icon: <Camera className="w-5 h-5 text-orcsys-500" />,
    title: "Capture & Partage",
    description: "Capturez et partagez des documents instantanément."
  },
  {
    icon: <CreditCard className="w-5 h-5 text-orcsys-500" />,
    title: "Paiement intégré",
    description: "Intégrez des solutions de paiement sécurisées."
  },
  {
    icon: <CalendarCheck className="w-5 h-5 text-orcsys-500" />,
    title: "Abonnements",
    description: "Gérez facilement les abonnements et renouvellements."
  },
  {
    icon: <Bell className="w-5 h-5 text-orcsys-500" />,
    title: "Notifications",
    description: "Alertes personnalisées pour une meilleure interaction."
  },
  {
    icon: <QrCode className="w-5 h-5 text-orcsys-500" />,
    title: "Scanner QR",
    description: "Numérisation rapide pour accéder aux informations."
  },
  {
    icon: <Map className="w-5 h-5 text-orcsys-500" />,
    title: "Géolocalisation",
    description: "Localisez et suivez en temps réel sur une carte."
  },
  {
    icon: <UserCircle className="w-5 h-5 text-orcsys-500" />,
    title: "Authentification",
    description: "Sécurisez l'accès avec une authentification avancée."
  },
  {
    icon: <Sparkles className="w-5 h-5 text-orcsys-500" />,
    title: "Et bien d'autres!",
    description: "De nombreuses autres fonctionnalités disponibles."
  }
];

const Functionalities = () => {
  return (
    <section className="py-12 bg-slate-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-2">
            Des fonctionnalités{' '}
            <span className="text-orcsys-500">essentielles</span>
          </h2>
          <p className="text-base text-slate-600 max-w-2xl mx-auto">
            Intégrez rapidement les fonctionnalités indispensables à votre application.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 justify-items-center max-w-5xl mx-auto">
          {functionalities.map((func, index) => (
            <FunctionalityCard 
              key={index} 
              icon={func.icon} 
              title={func.title} 
              description={func.description} 
              index={index} 
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Functionalities; 
